import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Link} from "react-router-dom";
import {withTranslation} from "react-i18next";
import {ConfigLayoutMenuApi} from "../../services/Api/types";
import AppConfig from "../../services/AppConfig";

interface Props {
    links: ConfigLayoutMenuApi[]
}

const NavbarMenus = (props: Props) => {
    const menuRef = useRef<HTMLUListElement | null>(null);
    const initialLinks = useMemo(() => {
        return props.links.filter(link => link.type === "MENU").sort((a, b) => a.position - b.position || a.title.localeCompare(b.title))
    }, [props.links])
    const [visibleLinks, setVisibleLinks] = useState<ConfigLayoutMenuApi[]>(initialLinks);


    const getFullWidthIncludingMargins = (element?: HTMLElement | Element | null) => {
        if (!element) return 0;

        const rect = element.getBoundingClientRect();
        const style = window.getComputedStyle(element);

        const marginLeft = parseFloat(style.marginLeft) || 0;
        const marginRight = parseFloat(style.marginRight) || 0;

        return rect.width + marginLeft + marginRight;
    }

    useEffect(() => {
        const navbar = document.getElementById('main-navbar');

        const handleResize = () => {
            const navbarBrandContainer = document.getElementById('navbar-brand-container');
            const menu = menuRef.current;
            const navbarOptions = document.getElementById('navbar-options');

            if (!navbar || !menu || !navbarOptions || !navbarBrandContainer) return;

            const navbarWidth = getFullWidthIncludingMargins(navbar);
            const navbarChildrenWidth = Array.from(navbarOptions.children).map(child => getFullWidthIncludingMargins(child)).reduce((acc, cur) => acc + cur, 0);

            const linksElements = Array.from(menu.children);
            const newVisibleLinks = [];
            const logoWidth = getFullWidthIncludingMargins(document.querySelector('.navbar-brand'));
            const navbarBackWidth = getFullWidthIncludingMargins(document.querySelector('.navbar-back-btn'));
            let availableSpace = navbarWidth - navbarChildrenWidth - logoWidth - navbarBackWidth;

            for (let i = 0; i < linksElements.length; i++) {
                const linkElement = linksElements[i];
                const linkElementWidth = getFullWidthIncludingMargins(linkElement);

                if (linkElementWidth <= availableSpace) {
                    availableSpace -= linkElementWidth;
                    newVisibleLinks.push(initialLinks[i]);
                } else {
                    break;
                }
            }
            setVisibleLinks(newVisibleLinks);
        };

        if (!navbar) return;

        const handleResizeSafe = () => {
            requestAnimationFrame(() => {
                handleResize();
            });
        };

        const resizeObserver = new ResizeObserver(() => {
            handleResizeSafe();
        });
        resizeObserver.observe(navbar);

        window.addEventListener('resize', handleResizeSafe);

        handleResizeSafe();

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', handleResizeSafe);
        };
    }, [initialLinks]);

    if (AppConfig.isWidget()) return null;

    const renderStoreLinkView = function (storeLink: ConfigLayoutMenuApi) {
        if (storeLink.link.includes("http") || storeLink.link.includes("www")) {
            return (
                <a className="nav-link" href={storeLink.link}>
                    {storeLink.title}
                </a>
            )
        }

        return (
            <Link className="nav-link" to={`/${storeLink.link}`}>
                {storeLink.title}
            </Link>
        )
    }

    return (
        <>
            <div style={{
                position: 'absolute',
                visibility: 'hidden',
                pointerEvents: 'none',
                height: 0,
                overflow: 'hidden'
            }}>
                <ul className="navbar-nav navbar-nav-menus" ref={menuRef}>
                    {initialLinks.map((link) => (
                        <li className="nav-item" key={`measure-${link.title}-${link.link}-${link.type}`}>
                            {renderStoreLinkView(link)}
                        </li>
                    ))}
                </ul>
            </div>
            <ul className="navbar-nav navbar-nav-menus">
                {
                    visibleLinks.map((storeLink) =>
                        <li className="nav-item" key={`${storeLink.title}-${storeLink.link}-${storeLink.type}`}>
                            {renderStoreLinkView(storeLink)}
                        </li>
                    )
                }
            </ul>
        </>
    )
}
export default withTranslation()(NavbarMenus)